import { cloneDeep } from "lodash";

export const setSurveyStartTime = ({ schedule, startTime }) => {
  schedule.startTime = startTime;

  return cloneDeep(schedule);
};

export default setSurveyStartTime;
